<template>
    <div class="add-tag-config">
        <div class="config-field">
            <label>Eklenecek Etiketler</label>
            <a-select
                v-model="localConfig.tagIds"
                mode="multiple"
                placeholder="Etiket seçin"
                style="width: 100%;"
                :filter-option="filterOption"
                @change="emitChange"
            >
                <a-select-option
                    v-for="tag in tags"
                    :key="tag._id"
                    :value="tag._id"
                >
                    <span class="tag-option">
                        <span class="tag-color" :style="{ backgroundColor: tag.color }"></span>
                        {{ tag.name }}
                    </span>
                </a-select-option>
            </a-select>
            <small>Seçilen etiketler kişiye eklenecektir</small>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
import log2 from "../../../../../../utils/log2";

const log = log2("AddTagConfig");

export default {
    name: "AddTagConfig",
    props: {
        value: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            localConfig: { tagIds: [] }
        };
    },
    computed: {
        ...mapState({
            tags: state => state.tag.tags.data
        })
    },
    watch: {
        value: {
            handler(newVal) {
                if (newVal && JSON.stringify(newVal) !== JSON.stringify(this.localConfig)) {
                    this.localConfig = JSON.parse(JSON.stringify(newVal));
                }
            },
            immediate: true,
            deep: true
        }
    },
    methods: {
        emitChange() {
            this.$emit("input", JSON.parse(JSON.stringify(this.localConfig)));
        },

        filterOption(input, option) {
            return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
        }
    }
};
</script>

<style lang="scss" scoped>
.add-tag-config {
    .config-field {
        label {
            display: block;
            font-weight: 600;
            margin-bottom: 8px;
            color: #1a1a1a;
        }

        small {
            display: block;
            color: #999;
            font-size: 12px;
            margin-top: 6px;
        }

        .tag-option {
            display: flex;
            align-items: center;
            gap: 8px;

            .tag-color {
                width: 12px;
                height: 12px;
                border-radius: 50%;
                display: inline-block;
            }
        }
    }
}
</style>

